import React from "react";
import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import FooterPagination from "../../Pagination/FooterPagination";
import {
  ButtonGroup,
  DropdownToggle,
  Table,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import UserStatusBadge from "../../Badges/UserStatusBadge";

import { removeAccessInvite } from "../../../slices/general/thunk";
import Swal from "sweetalert2";

const InviteUsersTable = ({
  data,
  searchDone,
  searchParam,
  paginationProps,
  onRemoveAccess,
  onResendInvitation,
}) => {
  const dispatch = useDispatch();

  const isNotSearchResult = searchParam && !data.length && searchDone;
  const noData = data.length === 0 && !searchParam;

  const renderDropdownMenu = (user) => {
    const portalRoot = document.getElementById("portal-root");
    return portalRoot
      ? ReactDOM.createPortal(
        <DropdownMenu>
          {user.active === false && (
            <DropdownItem
              onClick={() => {
                onResendInvitation(user);
              }}
            >
              <i className="ri-mail-send-fill align-bottom me-2 text-muted"></i>
              Resend Invitation
            </DropdownItem>
          )}
          <DropdownItem
            onClick={() => {
              onRemoveAccess(user);
            }}
          >
            <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
            Remove Access
          </DropdownItem>
        </DropdownMenu>,
        portalRoot
      )
      : null;
  };

  return (
    <div>
      <Table className="table table-hover border table-centered align-middle table-nowrap mb-0">
        <thead className="bg" style={{ background: "var(--thead-bg)" }}>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {" "}
          {isNotSearchResult && (
            <tr>
              <td className="text-center" colSpan="12">
                No search results for "{searchParam}"
              </td>
            </tr>
          )}
          {noData && (
            <tr>
              <td className="text-center" colSpan="8">
                No invited users found
              </td>
            </tr>
          )}
          {data?.map((user) => (
            <tr className="cursor-pointer" key={user.id}>
              <td>{(user.firstName || "") + " " + (user.lastName || "")}</td>
              <td>{user.email}</td>

              <td>{user.phoneNumber}</td>

              <td className="text-start">
                <UserStatusBadge
                  status={user.active === true ? "active" : "invited"}
                  color={user.active === true ? "success" : "warning"}
                />
              </td>

              <td className="text-center">
                <ButtonGroup onClick={(e) => e.stopPropagation()}>
                  <UncontrolledDropdown className="dropdown d-inline-block">
                    <DropdownToggle
                      tag="button"
                      className="btn btn-soft-primary  btn-sm"
                    >
                      <i className="ri-more-fill align-middle"></i>
                    </DropdownToggle>
                    {renderDropdownMenu(user)}
                  </UncontrolledDropdown>
                </ButtonGroup>
              </td>
            </tr>
          ))}
        </tbody>
        {paginationProps.totalItems > 0 && (
          <tfoot>
            <FooterPagination {...paginationProps} />
          </tfoot>
        )}
      </Table>
      <div id="portal-root"></div>
    </div>
  );
};

export default InviteUsersTable;
